import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { displayTopicCompUtil, blind, entryPoint } from '../../utils/topicUtils';
import PresentationEditor from './PresentationEditor';

const PresentationContPageItem = ({obj, index, params}) => {

  const [modal, setModal] = useState(false);

  const showModal = ()=>{
    setModal(true);
  }

  const closeModal = ()=>{
    setModal(false);
  }

  const styles = {   
    item: {
      display: 'flex',
      justifyContent: 'center',
      flex: 1,
      position: 'relative'
    },
    editBtn:{
      background: '#fff',
      color: '#666',
      width: 23,
      height: 23,
      fontSize: 11,
      padding: 3,
      border: '1px solid #ccc',
      textAlign: 'center',
      borderRadius: '100%',
      position: 'absolute',
      top: 0,
      right: 0,
      zIndex: 999,
      outline: 'none',
      boxShadow: 'none',
      transition: 'none',
    },
  }

  return(
    <div style={styles.item}>

      {params.position < index && blind(params.container)}
      
      {params.edit && 
        <button onClick={showModal} style = {styles.editBtn}> 
          <FontAwesomeIcon icon={faCog} />
        </button>
      } 

      {displayTopicCompUtil(obj, entryPoint.presentation)}

      <Modal size='md' show={modal} onHide={closeModal} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title style={{fontSize:15}}>Editor</Modal.Title>
          <button type="button" onClick={closeModal} className="close">&times;</button>
        </Modal.Header>
        <Modal.Body> 
          <PresentationEditor obj={obj} close={closeModal} />
        </Modal.Body> 
      </Modal>

    </div>
  )
    
}

export default PresentationContPageItem;